import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal--close" data-modal--close-modal-ids-value='["companyInfoModal"]'
export default class extends Controller {
  static values = {
    modalIds: Array as unknown as string[]
  }

  declare modalIdsValue: string[]
  private modal?: Modal

  connect(): void {
    this.modalIdsValue.forEach((idName: string) => {
      this.closeModal(idName)
    })
  }

  private closeModal(idName: string): void {
    const modalElm = document.getElementById(idName)
    if (modalElm) {
      this.modal = Modal.getOrCreateInstance(modalElm)
      this.modal.hide()
    }
  }
}
